/* ADD GROUPS */
export const GET_EXAM = "GET_EXAM"
export const GET_EXAM_SUCCESS = "GET_EXAM_SUCCESS"
export const GET_EXAM_CLEAN = "GET_EXAM_CLEAN"
export const GET_EXAM_ERROR = "GET_EXAM_ERROR"
